import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaList, FaTable } from 'react-icons/fa';
import NavItem from '../../components/NavItem';
import IconButton from '../../components/IconButton';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { pontoVirgula } from '../../util/util';
import ReactSelect from '../../components/ReactSelect';

export default function PainelProduto() {
    const perfil = localStorage.getItem("perfil");
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState([]);
    const [produtos, setProdutos] = useState([]);

    const buscar = () => {
        setFiltro({ ...filtro, ...{ buscando: true } });

        var filtroBuscar = {
            ...filtro,
            ...{ modulo: 'servicoOrcamento' }
        }

        if (filtroBuscar.cliente) {
            filtroBuscar.cliente = filtroBuscar.cliente.map(cliente => cliente.value).join(',');
        }

        api({
            method: 'get',
            action: '/produto',
            token: token,
            params: filtroBuscar
        })
            .then(response => {
                setProdutos(response.data.data);
                setFiltro({ ...filtro, ...{ buscando: false } });
            }).catch(err => {
                //console.log(err)
            })
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    {['diretor', 'gerenteevento', 'gerentebackoffice'].includes(perfil) ?
                        <NavItem to="/cadastroServicoOrcamento" icon={<FaPlus size={20} />} color="primary">Novo Item Orçamentário</NavItem> :
                        null}
                    <NavItem to="/produtoGrupo" icon={<FaList size={20} />} color="outline-dark">Grupos de Atributos</NavItem>
                    <NavItem to="/produtoTipoAtributo" icon={<FaList size={20} />} color="outline-dark">Tipo Atributos</NavItem>
                    <NavItem to="/produtoAtributo" icon={<FaList size={20} />} color="outline-dark">Atributos</NavItem>
                    <NavItem to="/servicoOrcamentoRelatorio" icon={<FaTable size={20} />} color="outline-dark">Relatório de Itens</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Itens Orçamentários</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            id="cliente"
                                                            isMulti={true}
                                                            value={filtro.cliente || []}
                                                            onChange={(e) => {
                                                                filtro.cliente = filtro.cliente || [];
                                                                filtro.cliente = e;
                                                                setFiltro({ ...filtro });
                                                            }}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipoCadastro: "cliente",
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Buscar pelo nome do serviço"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            progressComponent={<div>Buscando...</div>}
                                            noDataComponent="Nenhum registro"
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: (row) => {
                                                        if (['diretor', 'gerenteevento', 'gerentebackoffice'].includes(perfil)) {
                                                            return <IconButton
                                                                small={true}
                                                                to={"/cadastroServicoOrcamento/" + row.id}
                                                                icon={<FaPen size={20} />}
                                                                color="primary">Alterar</IconButton>;
                                                        }
                                                        return false;
                                                    },
                                                    width: "120px",
                                                },
                                                {
                                                    name: 'Situação',
                                                    selector: row => row.situacaoRegistro ?? "",
                                                    sortable: true,
                                                    width: "80px",
                                                },
                                                {
                                                    name: 'Código',
                                                    selector: row => row.codigo ?? "",
                                                    sortable: true,
                                                    width: "70px",
                                                    right: true,
                                                },
                                                {
                                                    name: 'Código Fornecedor',
                                                    selector: row => row.codigoFornecedor ?? "", //Fora de Catálogo
                                                    sortable: true,
                                                    width: "160px",
                                                    right: true,
                                                },
                                                {
                                                    name: 'Nome',
                                                    selector: row => row.nome ?? "",
                                                    sortable: true,
                                                    cell: row => <div style={{ maxWidth: "350px", fontWeight: "bold" }}>{row.nome ? row.nome : ''}</div>
                                                },
                                                {
                                                    name: 'Grupo Orçamentário',
                                                    selector: row => row.superior?.nome ?? "",
                                                    sortable: true,
                                                    width: "200px",
                                                    cell: row => row.superior ? row.superior.codigo + ' - ' + row.superior.nome : ''
                                                },
                                                {
                                                    name: 'Cliente',
                                                    selector: row => row.cliente?.[0]?.nome ?? "",
                                                    sortable: true,
                                                    width: "300px",
                                                    cell: (row) => {
                                                        if (row.cliente && Array.isArray(row.cliente)) {
                                                            return <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                {row.cliente.slice(0, 2).map(cliente => {
                                                                    if (cliente.enderecomunicipio) {
                                                                        return <div key={cliente.codigo} style={{ fontSize: "10px" }}>{cliente.codigo + ' - ' + cliente.nome + ' - ' + cliente.enderecomunicipio.nome + ' - ' + cliente.enderecomunicipio.uf}</div>;
                                                                    } else {
                                                                        return <div key={cliente.codigo} style={{ fontSize: "10px" }}>{cliente.codigo + ' - ' + cliente.nome}</div>;
                                                                    }
                                                                })}
                                                                {row.cliente.length > 2 && <div style={{ fontSize: "10px" }}>...</div>}
                                                            </div>;
                                                        } else {
                                                            return "";
                                                        }
                                                    },
                                                },
                                                {
                                                    name: 'Preço',
                                                    selector: row => row.preco ?? "",
                                                    sortable: true,
                                                    width: "80px",
                                                    cell: row => pontoVirgula(row.preco)
                                                },
                                            ]}
                                            data={produtos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
